import { render, staticRenderFns } from "./AddProductVendor.vue?vue&type=template&id=91cd7eb0&scoped=true&"
import script from "./AddProductVendor.vue?vue&type=script&lang=js&"
export * from "./AddProductVendor.vue?vue&type=script&lang=js&"
import style0 from "./AddProductVendor.vue?vue&type=style&index=0&id=91cd7eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cd7eb0",
  null
  
)

component.options.__file = "AddProductVendor.vue"
export default component.exports